import cardClasses from './_card.module.scss';
/**
 * Card V3
 * @class
 * 
 */
export default class MusicCardV3 extends HTMLElement {
  layoutType = 'stack';
  static get observedAttributes() {
    return ['layout'];
  }

  /**
   * Return an object with layout orientation type (platform, user).
   * @returns {string[]}
   */
  get layoutTypeOptions() {
    return Object.freeze([
      'line',
      'semi-line-lt',
      'semi-line-rt',
      'semi-stack-bot',
      'semi-stack-top',
      'stack']);
  }

  get decorator() {
    return Object.freeze({
      'line': {
        'wrapper-elm': 'l-line-v3',
        'pos': 'line',
      },
      'semi-line-lt': {
        'wrapper-elm': 'l-line-v3',
        'pos': 'lt',
      },
      'semi-line-rt': {
        'wrapper-elm': 'l-line-v3',
        'pos': 'rt',
      },
      'semi-stack-bot': {
        'wrapper-elm': 'l-stack-v3',
        'pos': 'bot',
      },
      'semi-stack-top': {
        'wrapper-elm': 'l-stack-v3',
        'pos': 'top',
      },
      'stack': {
        'wrapper-elm': 'l-stack-v3',
        'pos': 'stack',
      }
    });
  }

  get elmClasses() {
    return Object.freeze({
      'base': 'c-card-v3',
      'image': 'c-card-v3__image'});
  }

  get template() {
    const modifierClass = `${this.elmClasses.base}--${this.decorator[this.layoutType]['pos']}`
    return `<section role="none" class="${cardClasses[this.elmClasses.base]}  ${cardClasses[modifierClass]}">
      ${this.card.innerHTML}
    </section>`;
  }

  connectedCallback() {
    this.card = this;

    this.innerHTML = this.template;
    
    const cardImage = this.firstChild.querySelector('[slot="card-media"]');

    cardImage.classList.add(cardClasses[this.elmClasses.image]);
  }

  updateLayoutClass() {
    if(this.card) {
      const newPosClass = `${this.elmClasses.base}--${this.decorator[this.layoutType]['pos']}`;
      this.firstChild.classList.forEach(className => {
        if (className.includes(`${this.elmClasses.base}--`)) {
          this.firstChild.classList.remove(className);
        }
      });
      this.firstChild.classList.add(cardClasses[newPosClass]);
      }
  }

  /**
   * Handle attribute value changes.
   *
   * @param {String} attrName - name of the attribute that has changed
   * @param {String} oldValue - previous value of the changed attribute
   * @param {String} newValue - new value of the changed attribute
   */
  attributeChangedCallback(attrName, oldValue, newValue) {
    if (newValue !== oldValue && attrName === 'layout') {
      if (newValue === '') {
        this.layoutType = 'stack';
      } else if (this.layoutTypeOptions.includes(newValue)) {
        this.layoutType = newValue;
        this.updateLayoutClass();
      } else throw new Error('MusicCardV3 layout value is not allowed');
    } 
  }
}